import { Card } from "../../ui-kit/Card/Card";
import { Text } from "../../ui-kit/Text/Text";

import styles from "./Zin.module.scss";

const getArticle = (id, src, title) => ({ id, src, title });
const data = [
  getArticle(
    1,
    "https://cryptoinfobase.com/wp-content/uploads/2019/04/cosmos-e1561441497567.jpg",
    "Для создания образа приходится утрировать"
  ),
  getArticle(
    2,
    "https://bits.media/upload/iblock/bde/razrabotchiki_cosmos_zapustyat_universalnuyu_detsentralizovannuyu_birzhu_gravity_v_sleduyushchem_mes.jpg",
    "Психолог А. Гоголев"
  ),
  getArticle(
    3,
    "https://www.artmajeur.com/medias/standard/s/u/suleymanovaart/artwork/10899775_cosmos.jpg",
    "Ответ Go Scum Go"
  ),
  getArticle(
    2,
    "https://bits.media/upload/iblock/bde/razrabotchiki_cosmos_zapustyat_universalnuyu_detsentralizovannuyu_birzhu_gravity_v_sleduyushchem_mes.jpg",
    "Психолог А. Гоголев"
  ),
  getArticle(
    1,
    "https://cryptoinfobase.com/wp-content/uploads/2019/04/cosmos-e1561441497567.jpg",
    "Для создания образа приходится утрировать"
  ),
  getArticle(
    3,
    "https://www.artmajeur.com/medias/standard/s/u/suleymanovaart/artwork/10899775_cosmos.jpg",
    "Ответ Go Scum Go"
  ),
];

export const Zin = () => {
  return (
    <div className={styles.articles}>
      <Text title>#2/2018 Литературный журнал «Красный Шекспир»</Text>
      {data.map((article) => (
        <Card
          href={`/zins/article/${article.id}`}
          title={article.title}
          src={article.src}
        />
      ))}
    </div>
  );
};
